import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { GetCustomerRechargeHistoryProps } from "_interfaces/http-requests/customer";
import { RechargeHistoryProps } from "_interfaces/myAccount/rechargeHistory";
import { RechargeHistoryFilterModel } from "_models/data/recharge/data.recharge-history-filter.model";
import {
  filterNonNullValues,
  formatPriceWithDelimiter,
} from "functions/helper";
import { GetCustomerRechargeHistory } from "functions/http-requests/customer";
import moment from "moment";
import SectionTitle from "parts/sectionTitle";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toggleLoading } from "state/slice/loading";
import RechargeHistoryFilter from "./rechargeHistoryFilter";

const RechargeHistoryLayout = () => {
  const Dispatch = useDispatch();

  const [state, setState] = useState<RechargeHistoryProps | null>(null);
  const [filters, setFilters] = useState<RechargeHistoryFilterModel>(
    new RechargeHistoryFilterModel(),
  );

  const [refresh, setRefresh] = useState<boolean>(false);

  const handleRefresh = () => setRefresh(!refresh);

  useEffect(() => {
    if (!filters?.fromDate || !filters?.toDate) return;

    Dispatch(toggleLoading(true));
    let fetchList: (() => void) | null = () => {
      let PAYLOAD_DATA: GetCustomerRechargeHistoryProps["DATA"] = {
        fromDate: filters?.fromDate
          ? moment(filters?.fromDate).format("YYYY-MM-DD")
          : undefined,
        toDate: filters?.toDate
          ? moment(filters?.toDate).format("YYYY-MM-DD")
          : undefined,
      };
      PAYLOAD_DATA = filterNonNullValues(PAYLOAD_DATA);

      GetCustomerRechargeHistory({
        DATA: PAYLOAD_DATA,
      })
        .then((res) => {
          setState(res?.data?.data);
        })
        .catch(() => {})
        .finally(() => {
          Dispatch(toggleLoading(false));
        });
    };
    fetchList();
    return () => {
      fetchList = null;
    };
  }, [Dispatch, refresh]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
        }}
      >
        <SectionTitle title="Recharge History" />

        <RechargeHistoryFilter
          filters={filters}
          setFilters={setFilters}
          handleRefresh={handleRefresh}
        />
      </Box>

      <Box pt={5}>
        {!filters?.fromDate || !filters?.toDate ? (
          <Typography pb={1} fontSize={16} textAlign="center">
            Select the date range to view recharge history.
          </Typography>
        ) : state?.rechargeSummary?.length ? (
          <>
            <Box display="flex" flexDirection="column" gap={3}>
              {state?.rechargeSummary?.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    boxShadow: "0 .25rem 0.5rem rgba(0,0,0,.05)",
                    borderRadius: 3,
                    padding: 3,
                  }}
                >
                  <Box fontSize={14}>
                    <RenderRow
                      label="Recharge Type"
                      value={`${item?.rechargeType}`}
                    />
                    <RenderRow
                      label="Total Recharge Amount"
                      value={
                        item?.sumOfRechargeAmounts
                          ? formatPriceWithDelimiter(
                              item?.sumOfRechargeAmounts,
                              false,
                            )
                          : 0
                      }
                    />
                  </Box>
                </Box>
              ))}
            </Box>
          </>
        ) : (
          <Typography pb={1} fontSize={16} textAlign="center">
            Recharge History Not Found
          </Typography>
        )}
      </Box>
    </>
  );
};

interface RowProps {
  label: string;
  value: string | number;
}
const RenderRow: React.FC<RowProps> = ({ label, value }) => {
  return (
    <>
      <Box
        pt={0.5}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography fontSize="inherit" className="fc-grey">
          {label}
        </Typography>
        <Typography textAlign="right">{value}</Typography>
      </Box>
    </>
  );
};

export default RechargeHistoryLayout;
